import { render, staticRenderFns } from "./Current.vue?vue&type=template&id=96a363f6&scoped=true&"
import script from "./Current.vue?vue&type=script&lang=js&"
export * from "./Current.vue?vue&type=script&lang=js&"
import style0 from "./Current.vue?vue&type=style&index=0&id=96a363f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a363f6",
  null
  
)

export default component.exports